import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Product } from '../../components/products/products.component';

export type SelectionSource = 'todo' | 'upsell' | 'cross';

export interface SelectedProductEntry {
  todoId: string;
  product: Product;
  source: SelectionSource;
}

@Injectable({
  providedIn: 'root'
})
export class SelectedProductsService {

  private selections: SelectedProductEntry[] = [];
  private selectionsSubject = new BehaviorSubject<SelectedProductEntry[]>([]);

  public selections$ = this.selectionsSubject.asObservable();

  clear(): void {
    this.selections = [];
    this.emitChanges();
  }

  getSelectionsSnapshot(): SelectedProductEntry[] {
    return this.selections.map(entry => ({
      ...entry,
      product: { ...entry.product }
    }));
  }

  upsertSelection(todoId: string, product: Product, source: SelectionSource, quantity?: number): void {
    const existingIndex = this.selections.findIndex(entry => entry.todoId === todoId && entry.source !== 'cross');
    const existingQuantity = existingIndex >= 0 ? this.selections[existingIndex].product.quantity : undefined;
    const resolvedQuantity = quantity ?? existingQuantity ?? 1;

    const productWithQuantity: Product = {
      ...product,
      quantity: resolvedQuantity
    };

    const newEntry: SelectedProductEntry = {
      todoId,
      product: productWithQuantity,
      source
    };

    if (existingIndex >= 0) {
      this.selections[existingIndex] = newEntry;
    } else {
      this.selections.push(newEntry);
    }

    this.emitChanges();
  }

  addCrossSelection(baseTodoId: string, product: Product): void {
    const uniqueId = `${baseTodoId}-cross-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    const productWithQuantity: Product = { ...product, quantity: 1 };

    const newEntry: SelectedProductEntry = {
      todoId: uniqueId,
      product: productWithQuantity,
      source: 'cross'
    };

    this.selections.push(newEntry);
    this.emitChanges();
  }

  private emitChanges(): void {
    this.selectionsSubject.next(
      this.selections.map(entry => ({
        ...entry,
        product: { ...entry.product }
      }))
    );
  }
}
